import { render, staticRenderFns } from "./AccidentEdit.vue?vue&type=template&id=60795d47&scoped=true"
import script from "./AccidentEdit.vue?vue&type=script&lang=js"
export * from "./AccidentEdit.vue?vue&type=script&lang=js"
import style0 from "./AccidentEdit.vue?vue&type=style&index=0&id=60795d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60795d47",
  null
  
)

export default component.exports